import React, { useState, useEffect, useRef   } from "react";
import "./ConsultaSeguimiento.css";
import { useParams } from "react-router-dom";
import { addConsultaToHistoriaClinica, getHistoriaClinicaPorPaciente, getCatalogoDiagnosticos, getSugerenciasHistoricasExpediente,  } from "../../../../services/historiaClinica";
import { getPacienteById } from "../../../../services/pacientes";
import { useNavigate } from "react-router-dom";
import { mapFrontendToBackend } from "../../../../services/variableMapper";
import Accordion from "../Accordion";
import ModalConfirmacion from "../ModalesEdicion/ModalConfirmacion";
import DropzoneArchivos from "../../../../utils/DropzoneArchivos";
import "../../../../utils/DropzoneArchivos.css";
import { getMedicoAuth, getPerfilMedico, validarCluesCatalogo, validarCluesServicioAmigable, updatePerfilMedico, } from "../../../../services/usuarios";
import { normalizeEspecialidad } from "../../../../services/cuestionariocatalog";
import CuestionarioPorEspecialidadConsulta from "./CuestionarioPorEspecialidadConsulta";
import { toast } from "react-toastify";
import {validarFormatoSistolica,validarFormatoDiastolica,validarRangoSistolica, normalizarEnterosistolicaOnBlur, 
  validarDiastolicaNoMayorASistolica, validarSistolicaNoMenorADiastolica,
  validarRangoDiastolica,normalizarEnterodiastolicaOnBlur, validarFormatoPeso, validarRangoPeso, normalizarPesoOnBlur, 
  validarFormatoAltura, validarRangoAltura,normalizarAlturaOnBlur, 
  validarFormatoFrecuenciaCardiaca,validarRangoFrecuenciaCardiaca, normalizarEnterofrecuenciacardiacaOnBlur,
  validarFormatoFrecuenciaRespiratoria, normalizarEnterofrecuenciarespiratoriaOnBlur,
  validarRangoFrecuenciaRespiratoria, validarFormatoTemperatura, validarRangoTemperatura, normalizarTemperaturaOnBlur,
  validarFormatoSaturacionOxigeno,normalizarEnterosaturacionOnBlur,
  validarRangoSaturacionOxigeno,  validarFormatoCircunferenciaCintura, 
  normalizarEnteroCircunferenciaCinturaOnBlur, validarRangoCircunferenciaCintura, validarFormatoGlucemia, 
  normalizarEnteroGlucemiaOnBlur, validarRangoGlucemia, validarFechaConsultaNoFuturo, validarFechaConsultaNo48hAtras,
  calcularEdadEnFechaConsulta,
  calcularEdadMesesEnFechaConsulta,
  validarFechaConsultaNoAntesNacimientoMenor48h,
  validarFechaConsultaNoAntesNacimiento,
} from "../../../../utils/validaciones/expediente";
import {msgPresionSistolicaFueraRango,msgPresionDiastolicaFueraRango, msgDiastolicaMayorASistolica,
  msgFrecuenciaCardiacaFueraRango, msgFrecuenciaRespiratoriaFueraRango, msgTemperaturaFueraRango, 
  msgSaturacionOxigenoFueraRango, msgCircunferenciaCinturaFueraRango, msgGlucemiaFueraRango,
  msgAlturaFueraRango,msgPesoFueraRango, msgFechaConsultaFuturo, msgFechaConsulta48h, msgFechaConsultaAntesNacimiento,
   msgEdadPaciente,msgEdadRango,  
} from "../../../../utils/validaciones/mensajes";
import { aplicaConfirmacionDiagnostica } from "../../../../utils/validaciones/elegibilidad";
import { getCatalogoServiciosAtencion } from "../../../../services/historiaClinica";
import { validarEdadServicio, esEstablecimientoEspecializadoUNEME  } from "../../../../utils/validaciones/catalogos";
import ModalPerfilIncompleto from "../ModalesEdicion/ModalPerfilIncompleto";
import ModalPacienteIncompleto, { obtenerFaltantesPacienteNOM024 } from "../ModalesEdicion/ModalPacienteIncompleto";
import ModalConsultaIncompleta from "../ModalesEdicion/ModalConsultaIncompleta";
import ModalEdadPaciente, { pacienteTieneEdadPermitida,prestadorTieneEdadPermitida, } from "../ModalesEdicion/ModalEdadPaciente";
import { useVerificarPerfil } from "../../../../utils/validaciones/hooks";
import SwitchDesconocido from "../SwitchDesconocido";
import CampoAsistido from "../../../../utils/asistenciacaptura/campoasistido";

const valorVacioNOM = (valor) => {
  return (
    valor === undefined ||
    valor === null ||
    String(valor).trim() === "" ||
    String(valor).trim() === "-1"
  );
};

const obtenerFaltantesConsultaNOM024 = (consulta,aplicaUneme,diagnosticosSeleccionados = {},edadPaciente = null) => {
  if (!consulta) return [];

  const faltantes = [];

  if (valorVacioNOM(consulta.fechaConsulta)) {
    faltantes.push("Fecha y hora de la consulta");
  }

  if (valorVacioNOM(consulta.servicioAtencion)) {
    faltantes.push("Servicio de atención");
  }

  if (valorVacioNOM(consulta?.signosVitales?.sistolica) || valorVacioNOM(consulta?.signosVitales?.diastolica)) {
  faltantes.push("Presión arterial (sistólica y diastólica)");
}
  if (valorVacioNOM(consulta?.signosVitales?.peso)) {
    faltantes.push("Peso");
  }

  if (valorVacioNOM(consulta?.signosVitales?.altura)) {
    faltantes.push("Talla");
  }

  if (valorVacioNOM(consulta.codigoCIEDiagnostico1)) {
    faltantes.push("Diagnóstico CIE principal");
  }

  if (valorVacioNOM(consulta.cartillaSalud)) {
    faltantes.push("Cartilla de salud");
  }
  
  const signosVitales = consulta?.signosVitales || {};
  const glucemia = signosVitales.glucemia;
  const resultadoObtenidoaTravesde = signosVitales.resultadoObtenidoaTravesde;

  const hayGlucemiaRegistrada =
    !valorVacioNOM(glucemia) &&
    String(glucemia).trim() !== "0";

  const origenGlucosaValido = ["1", "2"].includes(
    String(resultadoObtenidoaTravesde).trim()
  );

  if (hayGlucemiaRegistrada && !origenGlucosaValido) {
    faltantes.push("Origen del resultado de glucosa");
  }

    const primeraVezAnio = consulta?.primeraVezAnio;
  const primeraVezUneme = consulta?.primeraVezUneme;

  const requierePrimeraVezUneme =
    aplicaUneme === true &&
    String(primeraVezAnio).trim() === "1";

  const primeraVezUnemeValida = ["0", "1"].includes(
    String(primeraVezUneme).trim()
  );

  if (requierePrimeraVezUneme && !primeraVezUnemeValida) {
    faltantes.push("Primera vez en UNEME");
  }

const atencionPregestacionalRT = consulta?.atencionPregestacionalRT;
const riesgo = consulta?.riesgo;

const requiereRiesgoPregestacional =
  String(atencionPregestacionalRT).trim() === "0" ||
  String(atencionPregestacionalRT).trim() === "1";

if (requiereRiesgoPregestacional && valorVacioNOM(riesgo)) {
  faltantes.push("Riesgos detectados en atención pregestacional");
}

const relacionTemporalEmbarazo = consulta?.relacionTemporalEmbarazo;
const trimestreGestacional = consulta?.trimestreGestacional;

const requiereTrimestreGestacional =
  String(relacionTemporalEmbarazo).trim() === "0" ||
  String(relacionTemporalEmbarazo).trim() === "1";

const trimestreGestacionalValido = ["1", "2", "3"].includes(
  String(trimestreGestacional).trim()
);

if (requiereTrimestreGestacional && !trimestreGestacionalValido) {
  faltantes.push("Trimestre gestacional");
}

const pruebaEDI = String(consulta?.pruebaEDI ?? "").trim();
const resultadoEDI = String(consulta?.resultadoEDI ?? "").trim();

const requiereResultadoEDI = pruebaEDI === "1" || pruebaEDI === "2";

if (requiereResultadoEDI && valorVacioNOM(resultadoEDI)) {
  faltantes.push("Resultado prueba EDI");
}

const edasRT = String(consulta?.edasRT ?? "").trim();
const edasPlanTratamiento = String(consulta?.edasPlanTratamiento ?? "").trim();
const recuperadoDeshidratacion = String(consulta?.recuperadoDeshidratacion ?? "").trim();

const requiereEdasPlan = edasRT === "0" || edasRT === "1";

if (requiereEdasPlan && valorVacioNOM(edasPlanTratamiento)) {
  faltantes.push("Plan de tratamiento EDA");
}

const requiereRecuperadoDeshidratacion =
  requiereEdasPlan && (edasPlanTratamiento === "2" || edasPlanTratamiento === "3");

if (requiereRecuperadoDeshidratacion && valorVacioNOM(recuperadoDeshidratacion)) {
  faltantes.push("Recuperación de deshidratación");
}

const irasRT = String(consulta?.irasRT ?? "").trim();
const irasPlanTratamiento = String(consulta?.irasPlanTratamiento ?? "").trim();

const requiereIrasPlan = irasRT === "0" || irasRT === "1";

if (requiereIrasPlan && valorVacioNOM(irasPlanTratamiento)) {
  faltantes.push("Plan de tratamiento IRA");
}

[2, 3].forEach((num) => {
  const cieAbierto =
    consulta[`codigoCIEDiagnostico${num}`] ||
    consulta[`primeraVezDiagnostico${num}`] !== null;

  if (!cieAbierto) return;

  const primeraVez = consulta[`primeraVezDiagnostico${num}`];

  if (!["0", "1"].includes(String(primeraVez ?? "").trim())) {
    faltantes.push(`Primera vez diagnóstico ${num}`);
  }

  if (
    ["0", "1"].includes(String(primeraVez ?? "").trim()) &&
    valorVacioNOM(consulta[`codigoCIEDiagnostico${num}`])
  ) {
    faltantes.push(`Diagnóstico CIE ${num}`);
  }
});

[1, 2, 3].forEach((num) => {
  const dx = diagnosticosSeleccionados[num];

  const esPrimeraVez = num === 1
    ? String(consulta.relacionTemporal).trim() === "0"
    : consulta[`primeraVezDiagnostico${num}`] === 1;

  const apareceConfirmacion = aplicaConfirmacionDiagnostica(
    dx,
    edadPaciente,
    esPrimeraVez
  );

  if (!apareceConfirmacion) return;

  const valor = consulta[`confirmacionDiagnostica${num}`];

  if (!["0", "1"].includes(String(valor ?? "").trim())) {
    faltantes.push(`Confirmación diagnóstica ${num}`);
  }
});

  return faltantes;
};

const ConsultaSeguimiento = () => {
  
  const [paciente, setPaciente] = useState(null);
  const [, setIsLoading] = useState(false);
  const { id: pacienteId } = useParams(); // 📌 Obtiene el ID del paciente desde la URL
  const [showPacienteInfo, setShowPacienteInfo] = useState(false);
  const pacienteHeaderRef = useRef(null);
  const [consultaFiles, setConsultaFiles] = useState([]); //ESTOS SON LOS LABS
  const navigate = useNavigate();
  const { faltantes } = useVerificarPerfil();
  const [perfil, setPerfil] = useState(null);
  const [medico, setMedico] = useState(null); 
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [serviciosAtencion, setServiciosAtencion] = useState([]);
  const [aplicaUneme, setAplicaUneme] = useState(false);
  const [cluesEsServicioAmigable, setCluesEsServicioAmigable] = useState(false);
  const [primeraVezAnioPreview, setPrimeraVezAnioPreview] = useState(null);
  const [cieFields, setCieFields] = useState([1]);
  const [cieActivo, setCieActivo] = useState(1);
  const [diagnosticoBusqueda, setDiagnosticoBusqueda] = useState({ 1: "", 2: "", 3: "" });
  const [diagnosticosCatalogo, setDiagnosticosCatalogo] = useState([]);
  const [diagnosticosSeleccionados, setDiagnosticosSeleccionados] = useState({ 1: null, 2: null, 3: null });
  const [consulta, setConsulta] = useState({
    motivo: "",
    evolucion: "",
    servicioAtencion: "",
    primeraVezAnio: null,
    primeraVezUneme: null,
    signosVitales: {
      temperatura: "",
      sistolica: "",
      diastolica: "",
      frecuenciaCardiaca: "",
      frecuenciaRespiratoria: "", // <- Lo agregas
      saturacionOxigeno: "",      // <- Lo agregas
      circunferenciaCintura: "",
      glucemia: "",
      glucosaMedida: false, 
      tipoMedicion: "-1",
      resultadoObtenidoaTravesde: "-1",
      sintomaticoRespiratorioTb: "-1",
      intervencionesSMyA: "-1",
      peso: "",
      altura: "",
    },
    exploracion_otros: "",      // exploración física (otros)
    imc: "",                    // calculado
    categoria_imc: "",          // calculado
    diagnostico: "",
    relacionTemporal: null,
    codigoCIEDiagnostico1: "",
    codigoCIEDiagnostico2: "",
    codigoCIEDiagnostico3: "",
    primeraVezDiagnostico2: null,
    primeraVezDiagnostico3: null,
    confirmacionDiagnostica1: null,
    confirmacionDiagnostica2: null,
    confirmacionDiagnostica3: null,
    pronostico: "",
    tratamiento: "",
    medicamentos: [],
    proximaCita: "",
    laboratorios: [],
    laboratorios_texto: "",
    indicacionesAdicionales: "",
  });
  const fechaConsultaAnteriorRef = useRef(consulta.fechaConsulta);

  // ✅ Medicamentos (bloque dinámico, consistente con receta / historia)
  const [medicamentos, setMedicamentos] = useState(
    Array.isArray(consulta.medicamentos) && consulta.medicamentos.length
      ? consulta.medicamentos
      : [{ nombre: "", indicaciones: "", vademecum_id: null }]
  );

  // Sincroniza al objeto consulta (igual que HistoriaClinicaFormCommon)
  useEffect(() => {
    setConsulta((prev) => ({
      ...prev,
      medicamentos,
    }));
  }, [medicamentos]);


  const [isFechaEditable, setIsFechaEditable] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [faltantesConsulta, setFaltantesConsulta] = useState([]);
  const [showConsultaIncompleta, setShowConsultaIncompleta] = useState(false);
   // Indica qué validación de edad debe mostrar el modal bloqueante:
  // - null: no mostrar modal.
  // - "paciente": el paciente supera los 120 años.
  // - "prestador": el prestador supera los 90 años.
  const [tipoEdadBloqueante, setTipoEdadBloqueante] = useState(null);

  useEffect(() => {
    const now = new Date();
    const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    setConsulta((prevConsulta) => ({ ...prevConsulta, fechaConsulta: localISOTime }));
  }, []);
  const toggleFechaEditable = () => {
    setIsFechaEditable(!isFechaEditable);
  };

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConsulta((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSignosVitalesChange = (e) => {
    const { name, value } = e.target;
    setConsulta((prev) => ({
      ...prev,
      signosVitales: {
        ...prev.signosVitales,
        [name]: value,
      },
    }));
  };

    // Rubros visibles en SEGUIMIENTO (alineados con Alta)
  const RUBROS = [
    { id: "rubro-consulta",   label: "Datos de la consulta" },
    { id: "rubro-aparatos",   label: "Interrogatorio" },
    { id: "rubro-exploracion",label: "Exploración física" },
    { id: "rubro-estudios",   label: "Estudios" },
    { id: "rubro-dx-plan",    label: "Diagnóstico, pronóstico y plan" },
    { id: "rubro-cuestionario-especialidad-consulta", label: "Cuestionario específico (consulta)" },
  ];

  // Estado de acordeones (por defecto abre “Datos de la consulta”)
  const [openRubros, setOpenRubros] = useState(
    RUBROS.reduce((acc, r) => ({ ...acc, [r.id]: r.id === "rubro-consulta" }), {})
  );

  // Toggle individual y expandir/contraer todo
  const toggleRubro = (id) =>
    setOpenRubros((prev) => ({ ...prev, [id]: !prev[id] }));

  const allOpen = Object.values(openRubros).every(Boolean);
  const handleToggleAll = () =>
    setOpenRubros((prev) =>
      Object.keys(prev).reduce((acc, k) => ({ ...acc, [k]: !allOpen }), {})
    );

  // Scroll suave a la sección anclada
  const scrollToAnchor = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleOcultarSugerenciaHistorica = async (campo, valor) => {
  const valorLimpio = String(valor || "").trim();

  if (!campo || !valorLimpio) return;

  const configActual =
    perfil?.config_sugerencias_historicas &&
    typeof perfil.config_sugerencias_historicas === "object"
      ? perfil.config_sugerencias_historicas
      : {};

  const configCampoActual =
    configActual?.[campo] &&
    typeof configActual[campo] === "object"
      ? configActual[campo]
      : {};

  const ocultosActuales = Array.isArray(configCampoActual.ocultos)
    ? configCampoActual.ocultos
    : [];

  const normalizar = (texto) =>
    String(texto || "")
      .trim()
      .replace(/\s+/g, " ");

  const yaOculto = ocultosActuales.some(
    (item) => normalizar(item) === normalizar(valorLimpio)
  );

  if (yaOculto) return;

  const nuevaConfig = {
    ...configActual,
    [campo]: {
      ...configCampoActual,
      ocultos: [...ocultosActuales, valorLimpio],
    },
  };

  await updatePerfilMedico({
    config_sugerencias_historicas: nuevaConfig,
  });

  setPerfil((prev) => ({
    ...(prev || {}),
    config_sugerencias_historicas: nuevaConfig,
  }));
};

  useEffect(() => {
  const fetchPaciente = async () => {
    try {
      setIsLoading(true);
      const pacienteEncontrado = await getPacienteById(pacienteId);
      
      if (!pacienteEncontrado) {
        alert("No se encontró el paciente con este ID");
        navigate("/dashboard/pacientes");
        return;
      }
      
      setPaciente(pacienteEncontrado);

      // (opcional) aquí NO necesitas setHistoria porque estás en seguimiento,
      // solo quieres mostrar el nombre del paciente
      setIsLoading(false);
    } catch (error) {
      console.error("Error al obtener datos del paciente:", error);
      alert("Error al cargar los datos del paciente");
      setIsLoading(false);
    }
  };

  if (pacienteId) {
    fetchPaciente();
  }
}, [pacienteId, navigate]);

useEffect(() => {
  if (!perfil?.nom024) return;
  if (!paciente?.fecha_nacimiento) return;
  if (!consulta?.fechaConsulta) return;

  const edadPaciente = calcularEdadEnFechaConsulta(
    paciente.fecha_nacimiento,
    consulta.fechaConsulta
  );

  if (edadPaciente > 120) {
    msgEdadPaciente();
  }
}, [
  perfil?.nom024,
  paciente?.fecha_nacimiento,
  consulta?.fechaConsulta
]);

// 🟦 Restaurar borrador si existe y corresponde a este paciente
 useEffect(() => {
   const raw = localStorage.getItem("salvir_draft_consulta");
   if (!raw) return;

   try {
     const draft = JSON.parse(raw);
     if (draft.paciente_id === pacienteId && draft.consulta) {
      toast.info("Se restauró un borrador temporal, revisa tu información y laboratorios antes de guardar, ya que este borrador no se conservará.")
       setConsulta((prev) => ({
         ...prev,
         ...draft.consulta
       }));
     }
   } catch (e) {
     console.error("❌ Error restaurando borrador de consulta:", e);
   }

   // 🟦 Borrar después de restaurar (idéntico a Historia)
   localStorage.removeItem("salvir_draft_consulta");
 }, [pacienteId]);

useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const [m, p, servicios] = await Promise.all([getMedicoAuth(), getPerfilMedico(), getCatalogoServiciosAtencion()]);
          if (!vivo) return;
          setMedico(m || null);
          setPerfil(p || {});

          const cluesMedico = m?.perfil?.clues || p?.clues || p?.perfil?.clues;
          
          let esServicioAmigable = false;
          if (cluesMedico) {
            const establecimiento = await validarCluesCatalogo(cluesMedico);
            setAplicaUneme(esEstablecimientoEspecializadoUNEME(establecimiento));
            esServicioAmigable = await validarCluesServicioAmigable(cluesMedico);
            setCluesEsServicioAmigable(esServicioAmigable);
          } else {
            setAplicaUneme(false);
            setCluesEsServicioAmigable(false);
          }

          const serviciosFiltrados = servicios.filter(s =>
                validarEdadServicio(
                  s.CATALOG_KEY,
                  calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, consulta?.fechaConsulta),
                  esServicioAmigable
                )
            );
          setServiciosAtencion(serviciosFiltrados);
      } catch (e) {
        console.error(e);
      }
    })();
    return () => { vivo = false; };
  }, [paciente?.fecha_nacimiento, consulta?.fechaConsulta]);

  // especialidad habilitada en seed de historia (si existe)
  const enabledEntry = Array.isArray(perfil?.config_cuestionario?.historia)
    ? perfil.config_cuestionario.historia.find((s) => s && s.enabled)
    : null;

  // selected_keys explícitos para CONSULTA (respetar [] ⇒ Set vacío)
  const selectedKeysConsulta = React.useMemo(() => {
    const raw = perfil?.config_cuestionario?.custom?.consulta?.selected_keys;
    return Array.isArray(raw) ? new Set(raw) : null;
  }, [perfil]);

  // fallback de especialidad: seed.historia.enabled → medico.especialidad → null
  const especialidadConsulta = React.useMemo(() => {
    return enabledEntry?.key || normalizeEspecialidad(medico?.especialidad) || null;
  }, [enabledEntry, medico]);


  //ESTE ES PARA LA INFO DEL PACIENTE
       useEffect(() => {
          if (!showPacienteInfo) return;
          const onMouseDown = (e) => {
            if (pacienteHeaderRef.current && !pacienteHeaderRef.current.contains(e.target)) {
              setShowPacienteInfo(false);
            }
          };
          document.addEventListener("mousedown", onMouseDown);
          return () => document.removeEventListener("mousedown", onMouseDown);
        }, [showPacienteInfo]);
        
    useEffect(() => {
    const pesoRaw = consulta.signosVitales?.peso;
    const alturaRaw = consulta.signosVitales?.altura;

    // Si peso o talla son 999 (desconocido), no calcular IMC
    if (String(pesoRaw) === "999" || String(alturaRaw) === "999") {
      setConsulta(prev => ({ ...prev, imc: "", categoria_imc: "" }));
      return;
    }

    const peso = parseFloat(pesoRaw);
    const altura = parseFloat(alturaRaw);

    if (!isNaN(peso) && peso > 0 && !isNaN(altura) && altura > 0) {
      const h = altura < 10 ? altura : altura / 100; // acepta m o cm
      const imcNum = +(peso / (h * h)).toFixed(2);

      let cat = "";
      if (imcNum < 18.5) cat = "Bajo peso";
      else if (imcNum < 25) cat = "Peso normal";
      else if (imcNum < 30) cat = "Sobrepeso";
      else if (imcNum < 35) cat = "Obesidad grado I";
      else if (imcNum < 40) cat = "Obesidad grado II";
      else cat = "Obesidad grado III";

      setConsulta(prev => ({ ...prev, imc: String(imcNum), categoria_imc: cat }));
    } else {
      setConsulta(prev => ({ ...prev, imc: "", categoria_imc: "" }));
    }
  }, [consulta.signosVitales?.peso, consulta.signosVitales?.altura]);

  // AGREGAR
  useEffect(() => {
    const terminoBusqueda = diagnosticoBusqueda[cieActivo] || "";
    const codigoActivo = consulta[`codigoCIEDiagnostico${cieActivo}`];
    const timer = setTimeout(async () => {
      if (codigoActivo) {
        setDiagnosticosCatalogo([]);
        return;
      }
      if (!terminoBusqueda || terminoBusqueda.length < 2) {
        setDiagnosticosCatalogo([]);
        return;
      }

      if (perfil?.nom024 && !consulta.fechaConsulta) {
        setDiagnosticosCatalogo([]);
        return;
      }

      if (
        perfil?.nom024 &&
        !["0", "1"].includes(String(consulta.relacionTemporal).trim())
      ) {
        setDiagnosticosCatalogo([]);
        return;
      }
      const data = await getCatalogoDiagnosticos(
        terminoBusqueda,
        pacienteId,
        consulta.relacionTemporal,
        consulta.fechaConsulta,
        cieActivo
      );
      setDiagnosticosCatalogo(data);

      if (data.length === 0) {
        toast.warning(
          "Sin resultados. El término ingresado no coincide con ningún diagnóstico disponible para este paciente según los criterios de edad y sexo establecidos, o bien no existe en el catálogo. Intente con otro término.",
          { toastId: "dx-sin-resultados" }
        );
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [
    cieActivo,
    diagnosticoBusqueda,
    consulta.relacionTemporal,
    consulta.fechaConsulta,
    consulta.codigoCIEDiagnostico1,
    consulta.codigoCIEDiagnostico2,
    consulta.codigoCIEDiagnostico3,
  ]);

  // AGREGAR
  useEffect(() => {
    const visibles = [1];
    if (consulta.codigoCIEDiagnostico2) visibles.push(2);
    if (consulta.codigoCIEDiagnostico3) visibles.push(3);
    setCieFields((prev) => (prev.length >= visibles.length ? prev : visibles));
  }, [consulta.codigoCIEDiagnostico2, consulta.codigoCIEDiagnostico3]);

 const agregarCampoCIE = () => {
  setCieFields((prev) => {
    if (prev.length >= 3) return prev;

    const siguiente = [1, 2, 3].find((n) => !prev.includes(n));
    if (!siguiente) return prev;

    if (siguiente !== 1) {
      setConsulta((c) => ({
        ...c,
        [`primeraVezDiagnostico${siguiente}`]: "",
        [`codigoCIEDiagnostico${siguiente}`]: "",
        [`confirmacionDiagnostica${siguiente}`]: null,
      }));
    }

    return [...prev, siguiente];
  });
};

  const eliminarCampoCIE = (num) => {
  const restantes = cieFields.filter((n) => n !== num);

  setConsulta((prev) => ({
    ...prev,
    [`codigoCIEDiagnostico${num}`]: "",
    [`primeraVezDiagnostico${num}`]: null,
    [`confirmacionDiagnostica${num}`]: null,
  }));

  setDiagnosticosSeleccionados((prev) => ({ ...prev, [num]: null }));
  setDiagnosticoBusqueda((prev) => ({ ...prev, [num]: "" }));
  setDiagnosticosCatalogo([]);
  setCieFields(restantes.length ? restantes : [1]);

  if (cieActivo === num) setCieActivo(restantes[0] || 1);
};

  const calcularPrimeraVezAnio = (historiaClinica, fechaConsultaActual) => {
  if (!fechaConsultaActual || !historiaClinica) return 1;

  const fechaActual = new Date(fechaConsultaActual);
  const anioActual = fechaActual.getFullYear();

  const fechaHistoria = historiaClinica.fecha_consulta
    ? new Date(historiaClinica.fecha_consulta)
    : null;

  const historiaCuentaComoPrevia =
    fechaHistoria &&
    fechaHistoria.getFullYear() === anioActual &&
    fechaHistoria < fechaActual;

  const consultasPrevias = Array.isArray(historiaClinica.consultas)
    ? historiaClinica.consultas
    : [];

  const existeConsultaPrevia = consultasPrevias.some((c) => {
    if (!c.fecha_consulta) return false;

    const fechaPrevia = new Date(c.fecha_consulta);

    return (
      fechaPrevia.getFullYear() === anioActual &&
      fechaPrevia < fechaActual
    );
  });

  return historiaCuentaComoPrevia || existeConsultaPrevia ? 0 : 1;
};

useEffect(() => {
  if (!perfil?.nom024 || !consulta.fechaConsulta || !pacienteId) return;

  let vivo = true;

  const calcularPreviewPrimeraVez = async () => {
    try {
      const historiaClinica = await getHistoriaClinicaPorPaciente(pacienteId);

      if (!vivo || !historiaClinica?.id) return;

      const primeraVez = calcularPrimeraVezAnio(
        historiaClinica,
        consulta.fechaConsulta
      );

      setPrimeraVezAnioPreview(primeraVez);

      setConsulta((prev) => ({
        ...prev,
       primeraVezAnio: 0,
       primeraVezUneme: !aplicaUneme
        ? -1
        : primeraVez === 0
          ? 0
          : prev.primeraVezAnio === primeraVez
            ? prev.primeraVezUneme
            : null,
      }));
    } catch (error) {
      console.error("Error calculando primera vez en el año:", error);
    }
  };

  calcularPreviewPrimeraVez();

  return () => {
    vivo = false;
  };
}, [perfil?.nom024, consulta.fechaConsulta, pacienteId, aplicaUneme]);

useEffect(() => {
  if (!perfil?.nom024) {
    fechaConsultaAnteriorRef.current = consulta.fechaConsulta;
    return;
  }

  const fechaAnterior = fechaConsultaAnteriorRef.current;
  const fechaActual = consulta.fechaConsulta;

  fechaConsultaAnteriorRef.current = fechaActual;

  if (!fechaAnterior || fechaAnterior === fechaActual) return;

  const hayCieSeleccionado =
    consulta.codigoCIEDiagnostico1 ||
    consulta.codigoCIEDiagnostico2 ||
    consulta.codigoCIEDiagnostico3;

  if (!hayCieSeleccionado) return;

  setConsulta((prev) => ({
    ...prev,
    codigoCIEDiagnostico1: "",
    codigoCIEDiagnostico2: "",
    codigoCIEDiagnostico3: "",
    primeraVezDiagnostico2: null,
    primeraVezDiagnostico3: null,
    confirmacionDiagnostica1: null,
    confirmacionDiagnostica2: null,
    confirmacionDiagnostica3: null,
  }));

  setDiagnosticosSeleccionados({ 1: null, 2: null, 3: null });
  setDiagnosticoBusqueda({ 1: "", 2: "", 3: "" });
  setDiagnosticosCatalogo([]);
  setCieFields([1]);
  setCieActivo(1);

  toast.info("La fecha de consulta cambió. Vuelve a seleccionar el diagnóstico CIE para aplicar los filtros de edad correctos.");
}, [perfil?.nom024, consulta.fechaConsulta]);

  
  const handleSubmit = async (e) => {
  if (e) e.preventDefault();
   setLoadingSubmit(true);

  
  try {
    
     localStorage.setItem(
       "salvir_draft_consulta",
      JSON.stringify({
         paciente_id: pacienteId,
         consulta: consulta
       })
     );
   } catch (e) {
     console.error("❌ No se pudo guardar borrador:", e);
   }
    setLoadingSubmit(true);
    try {
     
      const historiaClinica = await getHistoriaClinicaPorPaciente(pacienteId);
       
      if (historiaClinica === null) {
        try {
          localStorage.setItem(
            "salvir_redirect_after_login",
            window.location.href
          );
        } catch {}
        window.location.href = "/login";
        return;
      }
      if (!historiaClinica || !historiaClinica.id) {
        alert("No se encontró la historia clínica del paciente.");
        return;
      }
      
     const primeraVezAnioCalculada = calcularPrimeraVezAnio(
        historiaClinica,
        consulta.fechaConsulta
      );

      const primeraVezUnemeCalculada = !aplicaUneme
        ? -1
        : primeraVezAnioCalculada === 0
          ? 0
          : consulta.primeraVezUneme;

      const consultaParaEnviar = {
        ...consulta,
         primeraVezAnio: 0,
        primeraVezUneme: primeraVezUnemeCalculada,
      };

      const datosMapeados = mapFrontendToBackend(consultaParaEnviar, pacienteId);
      let formData = new FormData();
      // paciente_id obligatorio
      formData.append("historia_clinica_id", historiaClinica.id);
      
      // Campos normales (sin laboratorios)
      Object.keys(datosMapeados).forEach((key) => {
        if (key !== "laboratorios") {
          if (key === "medicamentos") {
            const normalizados = (datosMapeados[key] || []).map(m => ({
              nombre: m?.nombre || "",
              indicaciones: m?.indicaciones || "",
              vademecum_id: m?.vademecum_id ?? null
            }));
            formData.append("medicamentos", JSON.stringify(normalizados));
          } else {
          formData.append(key, datosMapeados[key] ?? "");
          }
        }
      });
            // Archivos de estudios → MISMO CAMPO DE HISTORIA (upload_laboratorios, (FLUJO VIEJO))
      //if (consultaFiles.length > 0) {
      //  consultaFiles.forEach((file) => {
      //    formData.append("upload_laboratorios", file);
      //  });
      //}
      //for (let pair of formData.entries()) {
        // debug opcional
      //  }
      
      const resultado = await addConsultaToHistoriaClinica(
          historiaClinica.id,
          formData, consultaFiles
        );

      if (resultado) {
        alert("Consulta de seguimiento registrada correctamente.");
        localStorage.removeItem("salvir_draft_consulta");
        setConsulta({
          motivo: "",
          evolucion: "",
          signosVitales: {
            temperatura: "",
            sistolica: "",
            diastolica: "",
            frecuenciaCardiaca: "",
            frecuenciaRespiratoria: "", // <- Lo agregas
           saturacionOxigeno: "",      // <- Lo agregas
            peso: "",
            altura: "",
          },
          diagnostico: "",
          codigoCIEDiagnostico1: "",
          codigoCIEDiagnostico2: "",
          codigoCIEDiagnostico3: "",
          tratamiento: "",
          proximaCita: "",
          laboratorios: [],
          indicacionesAdicionales: "",
          fechaConsulta: new Date().toISOString().slice(0, 16), // repone la fecha
        });
        setCieFields([1]);
        setCieActivo(1);
        setDiagnosticoBusqueda({ 1: "", 2: "", 3: "" });
        setDiagnosticosCatalogo([]);
         // limpia el formulario
        navigate("/dashboard/historias-clinicas");
      } else {
        alert("Error al guardar la consulta en la historia clínica.");
      }
    } catch (error) {
      
    const status = error?.response?.status;
    const data = error?.response?.data;
    const dataString = typeof data === "string" ? data : "";

    const isAuthExpired =
      status === 401 ||
      status === 403 ||
      (status === 400 && dataString.includes("CSRF")) ||   // CSRF real
      (status === 403 && dataString.includes("CSRF"));     // CSRF real

    if (isAuthExpired) {
      try {
        localStorage.setItem(
          "salvir_redirect_after_login",
          window.location.href
        );
      } catch {}

      window.location.href = "/login";
      return;
    }
    console.error("Error guardando la consulta:", error);
    alert("Ocurrió un error al registrar la consulta.");
  }
  setLoadingSubmit(false);
};
  
  const handleOpenConfirm = (e) => {
  e.preventDefault();
  
  if (!consulta?.fechaConsulta) {
    toast.error("La fecha y hora de la consulta es obligatoria.");
    setIsFechaEditable(true);
    return;
  }

  if (!validarFechaConsultaNoFuturo(consulta.fechaConsulta)) {
    msgFechaConsultaFuturo();
    setIsFechaEditable(true);
    return;
  }

  if (
   !validarFechaConsultaNoAntesNacimiento(
  consulta.fechaConsulta,
  paciente?.fecha_nacimiento
)
  ) {
    msgFechaConsultaAntesNacimiento();
    setIsFechaEditable(true);
    return;
  }

  
  // Validación bloqueante de edad máxima del paciente.
  // Compara su fecha de nacimiento contra la fecha de consulta.
  // El paciente puede tener hasta 120 años; desde 121 se bloquea.
  if (
    perfil?.nom024 &&
    !pacienteTieneEdadPermitida(
      paciente?.fecha_nacimiento,
      consulta?.fechaConsulta
    )
  ) {
     setTipoEdadBloqueante("paciente");
    return;
  }

  // Validación bloqueante de edad máxima del prestador.
  // Compara la fecha de nacimiento del médico contra la fecha de consulta.
  // El prestador puede tener hasta 90 años; desde 91 se bloquea.
  if (
    perfil?.nom024 &&
    !prestadorTieneEdadPermitida(
      medico?.fecha_nacimiento,
      consulta?.fechaConsulta
    )
  ) {
    setTipoEdadBloqueante("prestador");
    return;
  }

  if (perfil?.nom024) {
    const faltantes = obtenerFaltantesConsultaNOM024(
      consulta,
      aplicaUneme,
      diagnosticosSeleccionados,
      calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, consulta?.fechaConsulta)
    );

    if (faltantes.length > 0) {
      setFaltantesConsulta(faltantes);
      setShowConsultaIncompleta(true);
      return;
    }
  }

  setShowConfirm(true);
};

  return (
    <>
    <form onSubmit={handleOpenConfirm} className="consulta-seguimiento-form">
      <div>
        <h2>Captura de consulta de seguimiento</h2>
      </div>
       
      {/* Barra sticky con chips (Expandir/Contraer + navegación por rubro) */}
      <div className="tabs-container">
          <div className="paciente-header" ref={pacienteHeaderRef}>
            <h3 className="paciente-title">
              Paciente: {paciente?.nombre_completo}
            </h3>

            <button
              type="button"
              className={`paciente-toggle ${showPacienteInfo ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setShowPacienteInfo((v) => !v);
              }}
              aria-label="Ver datos del paciente"
              aria-expanded={showPacienteInfo}
            >
            ▼
            </button>

            {showPacienteInfo && (
              <div
                className="paciente-popover"
                onMouseDown={(e) => e.stopPropagation()}
              >
                <div><strong>Edad:</strong> {paciente?.edad || "—"}</div>
                <div><strong>Sexo:</strong> {paciente?.sexo || "—"}</div>
                {consulta?.motivo ? (
                  <div><strong>Motivo:</strong> {consulta.motivo}</div>
                ) : null}
              </div>
            )}
          </div>

        <div className="tabs-scroll">
          <button
            type="button"
            className="tab"
            onClick={handleToggleAll}
            title={allOpen ? "Contraer todo" : "Expandir todo"}
          >
            {allOpen ? "Contraer todo" : "Expandir todo"}
          </button>

          {RUBROS.map((r) => (
            <button
              key={r.id}
              type="button"
              className="tab"
              onClick={() => scrollToAnchor(r.id)}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>
         <div className="aviso-normatividad">
          
          <p>La información registrada forma parte del expediente clínico y, conforme 
            a la normatividad vigente, no puede modificarse posteriormente; únicamente es 
            posible añadir indicaciones adicionales.</p>
            {perfil?.nom024 && (
    <p><strong>Los campos con * son obligatorios</strong></p>
  )}
        </div>
      {/* 1) Datos de la consulta */}
      <Accordion
        title="Datos de la consulta"
        isOpen={openRubros["rubro-consulta"]}
        onToggle={() => toggleRubro("rubro-consulta")}
        anchorId="rubro-consulta"
      >
        <div className="rubro">
          <label>Fecha y Hora de la Consulta*</label>
          <div className="fecha-consulta-wrapper">
            <input
                type="datetime-local"
                name="fechaConsulta"
                value={consulta.fechaConsulta}
                onChange={handleInputChange}
                onBlur={(e) => {
                  if (!perfil?.nom024) return;

                  const now = new Date();
                  const resetFecha = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                    .toISOString()
                    .slice(0, 16);

                  const fechaCapturada = String(e.target.value || "").trim();

                  if (!fechaCapturada) return;

                  if (!validarFechaConsultaNoFuturo(fechaCapturada)) {
                    msgFechaConsultaFuturo();
                    setConsulta(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }

                  if (!validarFechaConsultaNo48hAtras(fechaCapturada)) {
                    msgFechaConsulta48h();
                    setConsulta(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }

                  if (!validarFechaConsultaNoAntesNacimientoMenor48h(fechaCapturada, paciente?.fecha_nacimiento)) {
                    msgFechaConsultaAntesNacimiento();
                    setConsulta(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }

                  // Validar edad mínima del prestador en la fecha de consulta
                  const edadPrestadorEnFechaConsulta = calcularEdadEnFechaConsulta(
                    medico?.fecha_nacimiento,
                    fechaCapturada
                  );

                  if (
                    edadPrestadorEnFechaConsulta !== null &&
                    edadPrestadorEnFechaConsulta < 18
                  ) {
                    msgEdadRango();
                    setConsulta(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }
                }}
                disabled={!isFechaEditable}
                required
              />
            <button type="button" className="editar-fecha-button" onClick={toggleFechaEditable}>
              {isFechaEditable ? "Bloquear" : "Editar"}
            </button>
          </div>
        </div>
        {perfil?.nom024 && (
         <div className="rubro">
          <label>Servicio de atención*</label>
          <select
            name="servicioAtencion"
            value={consulta.servicioAtencion ?? ""}
            onChange={handleInputChange}
          >
            <option value="">Seleccione</option>
            {serviciosAtencion.map((s) => (
              <option key={s.CATALOG_KEY} value={s.CATALOG_KEY}>
                {s.SERVICIOS_ATENCION}
              </option>
            ))}
          </select>
        </div>
        )}

        {perfil?.nom024 && aplicaUneme && (
          <div className="rubro">
            <label>¿Primera vez en UNEME?</label>
            <select
              name="primeraVezUneme"
              value={consulta.primeraVezUneme ?? ""}
              disabled={primeraVezAnioPreview === 0}
              onChange={(e) =>
                setConsulta((prev) => ({
                  ...prev,
                  primeraVezUneme: e.target.value === "" ? null : Number(e.target.value),
                }))
              }
            >
              <option value="">Seleccione</option>
              <option value="0">No</option>
              <option value="1">Sí</option>
            </select>

            {primeraVezAnioPreview === 0 && (
              <small style={{ color: "#6b7280", display: "block", marginTop: "6px" }}>
                Ya existe una atención previa este año.
              </small>
            )}
          </div>
        )}
      </Accordion>
      <Accordion
        title="Interrogatorio"
        isOpen={openRubros["rubro-aparatos"]}
        onToggle={() => toggleRubro("rubro-aparatos")}
        anchorId="rubro-aparatos"
      >
        <div className="rubro">
          <label htmlFor="motivo">Motivo de Consulta:</label>
          <textarea id="motivo" placeholder="Describa el motivo de consulta" name="motivo" value={consulta.motivo} onChange={handleInputChange}></textarea>
        </div>


        <div className="rubro">
          <label htmlFor="evolucion">Evolución del Paciente:</label>
          <textarea id="evolucion"  placeholder="Describa la evolución del paciente" name="evolucion" value={consulta.evolucion} onChange={handleInputChange}></textarea>
        </div>
        {perfil?.nom024 && (
        <div className="rubro">
        <label>¿Paciente sintomático respiratorio sospechoso de TB?</label>
        <select
          name="sintomaticoRespiratorioTb"
          value={consulta.sintomaticoRespiratorioTb ?? "-1"}
          onChange={handleInputChange}
        >
          <option value="-1">Seleccione</option>
          <option value="0">No</option>
          <option value="1">Sí</option>
        </select>
      </div>
       )}
      </Accordion>
       {/* 3) Exploración física (exploración_otros + SV + IMC) */}
      <Accordion
        title="Exploración física"
        isOpen={openRubros["rubro-exploracion"]}
        onToggle={() => toggleRubro("rubro-exploracion")}
        anchorId="rubro-exploracion"
      >
        <div className="rubro">
            {/* Exploración Física */}
            <h3>Exploración Física</h3>

            {/* Otros (Exploración) */}
            <CampoAsistido
              tipo="textarea"
              campo="exploracion_fisica"
              name="exploracion_otros"
              placeholder="Ingrese exploración física"
              value={consulta.exploracion_otros || ""}
              onChange={handleInputChange}
              plantillasHabilitadas={perfil?.plantillas_habilitadas ?? false}
              plantillasPersonalizadas={
                Array.isArray(perfil?.plantillas_personalizadas)
                  ? perfil.plantillas_personalizadas
                  : []
              }
            />

            {/* Signos vitales agrupados */}
            <div className="pa-wrapper">
              <h3>Signos Vitales</h3>
              <label>Presión Arterial (mmHg)</label>
{perfil?.nom024 && (
<SwitchDesconocido
  prendido={
    consulta.signosVitales.sistolica === "0" ||
    consulta.signosVitales.diastolica === "0"
  }
  onCambio={(prendido) => setConsulta({
    ...consulta,
    signosVitales: {
      ...consulta.signosVitales,
      sistolica: prendido ? "0" : "",
      diastolica: prendido ? "0" : ""
    }
  })}
/>)}
<div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  <input
    type="text"
    name="sistolica"
    placeholder="Ej: 120"
    value={consulta.signosVitales.sistolica}
    maxLength={3}
    disabled={consulta.signosVitales.diastolica === "0"}
    onChange={(e) => {
      const value = e.target.value;
      if (value === "") {
        handleSignosVitalesChange(e);
        return;
      }
      if (!validarFormatoSistolica(value)) return;
      handleSignosVitalesChange(e);
    }}
    onBlur={(e) => {
      const value = e.target.value;
      if (value === "") return;

      const normalizado = normalizarEnterosistolicaOnBlur(value);
      const diastolicaActual = consulta.signosVitales.diastolica;

      if (!validarRangoSistolica(normalizado)) {
        msgPresionSistolicaFueraRango();
        setConsulta({
          ...consulta,
          signosVitales: { ...consulta.signosVitales, sistolica: "" }
        });
      } else if (!validarSistolicaNoMenorADiastolica(normalizado, diastolicaActual)) {
        msgDiastolicaMayorASistolica();
        setConsulta({
          ...consulta,
          signosVitales: { ...consulta.signosVitales, sistolica: "" }
        });
      } else {
        e.target.value = normalizado;
        setConsulta({
          ...consulta,
          signosVitales: {
            ...consulta.signosVitales,
            sistolica: normalizado,
            ...(normalizado === "0" ? { diastolica: "0" } : {})
          }
        });
      }
    }}
  />

  <span>/</span>

  <input
    type="text"
    name="diastolica"
    placeholder="Ej: 80"
    value={consulta.signosVitales.diastolica}
    maxLength={3}
    disabled={consulta.signosVitales.sistolica === "0"}
    onChange={(e) => {
      const value = e.target.value;
      if (value === "") {
        handleSignosVitalesChange(e);
        return;
      }
      if (!validarFormatoDiastolica(value)) return;
      handleSignosVitalesChange(e);
    }}
    onBlur={(e) => {
      const value = e.target.value;
      if (value === "") return;

      const normalizado = normalizarEnterodiastolicaOnBlur(value);
      const sistolicaActual = consulta.signosVitales.sistolica;

      if (!validarRangoDiastolica(normalizado)) {
        msgPresionDiastolicaFueraRango();
        setConsulta({
          ...consulta,
          signosVitales: { ...consulta.signosVitales, diastolica: "" }
        });
      } else if (!validarDiastolicaNoMayorASistolica(sistolicaActual, normalizado)) {
        msgDiastolicaMayorASistolica();
        setConsulta({
          ...consulta,
          signosVitales: { ...consulta.signosVitales, diastolica: "" }
        });
      } else {
        e.target.value = normalizado;
        setConsulta({
          ...consulta,
          signosVitales: {
            ...consulta.signosVitales,
            diastolica: normalizado,
            ...(normalizado === "0" ? { sistolica: "0" } : {})
          }
        });
      }
    }}
  />
</div>
              <label>Frecuencia Cardiaca (lpm)</label>
                <input
                  type="text"
                  name="frecuenciaCardiaca"
                  placeholder="Ej: 70"
                  value={consulta.signosVitales.frecuenciaCardiaca}
                  maxLength={3}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "") {
                      handleSignosVitalesChange(e);
                      return;
                    }

                    if (!validarFormatoFrecuenciaCardiaca(value)) return;

                    handleSignosVitalesChange(e);
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (value === "") return;

                    const normalizado = normalizarEnterofrecuenciacardiacaOnBlur(value);

                    if (!validarRangoFrecuenciaCardiaca(normalizado)) {
                      msgFrecuenciaCardiacaFueraRango();
                      e.target.value = "";
                      handleSignosVitalesChange(e);
                    } else {
                      e.target.value = normalizado;
                      handleSignosVitalesChange(e);
                    }
                  }}
                />

                <label>Frecuencia Respiratoria (rpm)</label>
                  <input
                    type="text"
                    name="frecuenciaRespiratoria"
                    placeholder="Ej: 16"
                    value={consulta.signosVitales.frecuenciaRespiratoria}
                    maxLength={2}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "") {
                        handleSignosVitalesChange(e);
                        return;
                      }

                      if (!validarFormatoFrecuenciaRespiratoria(value)) return;

                      handleSignosVitalesChange(e);
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") return;

                      const normalizado = normalizarEnterofrecuenciarespiratoriaOnBlur(value);

                      if (!validarRangoFrecuenciaRespiratoria(normalizado)) {
                        msgFrecuenciaRespiratoriaFueraRango();
                        e.target.value = "";
                        handleSignosVitalesChange(e);
                      } else {
                        e.target.value = normalizado;
                        handleSignosVitalesChange(e);
                      }
                    }}
                  />
                <label>Temperatura (°C)</label>
                  <input
                    type="text"
                    name="temperatura"
                    placeholder="Ej: 36.5"
                    value={consulta.signosVitales.temperatura}
                    maxLength={4}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "") {
                        handleSignosVitalesChange(e);
                        return;
                      }

                      if (!validarFormatoTemperatura(value)) return;

                      handleSignosVitalesChange(e);
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") return;

                      const normalizado = normalizarTemperaturaOnBlur(value);

                      if (!validarRangoTemperatura(normalizado)) {
                        msgTemperaturaFueraRango();
                        e.target.value = "";
                        handleSignosVitalesChange(e);
                      } else {
                        e.target.value = normalizado;
                        handleSignosVitalesChange(e);
                      }
                    }}
                  />
                <label>Saturación de Oxígeno (%)</label>
                  <input
                    type="text"
                    name="saturacionOxigeno"
                    placeholder="Ej: 98"
                    value={consulta.signosVitales.saturacionOxigeno}
                    maxLength={3}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "") {
                        handleSignosVitalesChange(e);
                        return;
                      }

                      if (!validarFormatoSaturacionOxigeno(value)) return;

                      handleSignosVitalesChange(e);
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") return;

                      const normalizado = normalizarEnterosaturacionOnBlur(value);

                      if (!validarRangoSaturacionOxigeno(normalizado)) {
                        msgSaturacionOxigenoFueraRango();
                        e.target.value = "";
                        handleSignosVitalesChange(e);
                      } else {
                        e.target.value = normalizado;
                        handleSignosVitalesChange(e);
                      }
                    }}
                  />
                  {perfil?.nom024 && (
                  <div className="subrubro" style={{ marginTop: "12px" }}>
                    <h3>Metabólico</h3>

                    <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span>¿Se realizó medición de glucosa?</span>
                    </label>

                    <span style={{ fontSize: "12px", color: "#6b7280" }}>No / Sí</span>

                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={consulta.signosVitales.glucosaMedida || false}
                        onChange={(e) => {
                          const activar = e.target.checked;

                          setConsulta({
                            ...consulta,
                            signosVitales: {
                              ...consulta.signosVitales,
                              glucosaMedida: activar,
                              glucemia: activar
                                ? consulta.signosVitales.glucemia === "0"
                                  ? ""
                                  : consulta.signosVitales.glucemia
                                : "0",
                              tipoMedicion: activar ? consulta.signosVitales.tipoMedicion : "-1",
                              resultadoObtenidoaTravesde: activar
                                ? consulta.signosVitales.resultadoObtenidoaTravesde
                                : "-1"
                            }
                          });
                        }}
                      />
                      <span className="slider"></span>
                    </label>

                    {consulta.signosVitales.glucosaMedida && (
                      <>
                        <label>Glucemia (mg/dl)</label>
                        <input
                          type="text"
                          name="glucemia"
                          placeholder="Ej: 95"
                          value={consulta.signosVitales.glucemia || ""}
                          maxLength={3}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (value === "") {
                              setConsulta({
                                ...consulta,
                                signosVitales: {
                                  ...consulta.signosVitales,
                                  glucemia: value
                                }
                              });
                              return;
                            }

                            if (!validarFormatoGlucemia(value)) return;

                            setConsulta({
                              ...consulta,
                              signosVitales: {
                                ...consulta.signosVitales,
                                glucemia: value
                              }
                            });
                          }}
                          onBlur={(e) => {
                            const value = e.target.value;
                            if (value === "") return;

                            const normalizado = normalizarEnteroGlucemiaOnBlur(value);

                            if (
                              consulta.signosVitales.glucosaMedida &&
                              normalizado === "0"
                            ) {
                              msgGlucemiaFueraRango();

                              setConsulta({
                                ...consulta,
                                signosVitales: {
                                  ...consulta.signosVitales,
                                  glucemia: ""
                                }
                              });

                              return;
                            }

                            if (!validarRangoGlucemia(normalizado)) {
                              msgGlucemiaFueraRango();

                              setConsulta({
                                ...consulta,
                                signosVitales: {
                                  ...consulta.signosVitales,
                                  glucemia: ""
                                }
                              });
                            } else {
                              e.target.value = normalizado;

                              setConsulta({
                                ...consulta,
                                signosVitales: {
                                  ...consulta.signosVitales,
                                  glucemia: normalizado
                                }
                              });
                            }
                          }}
                        />
                      {consulta.signosVitales.glucemia &&
                       consulta.signosVitales.glucemia !== "0" && (
                        <>
                        <label>¿La medición fue en ayunas?</label>
                        <select
                          name="tipoMedicion"
                          value={consulta.signosVitales.tipoMedicion || "-1"}
                          onChange={(e) => {
                            setConsulta({
                              ...consulta,
                              signosVitales: {
                                ...consulta.signosVitales,
                                tipoMedicion: e.target.value
                              }
                            });
                          }}
                        >
                          <option value="-1">Seleccione</option>
                          <option value="0">No</option>
                          <option value="1">Sí</option>
                        </select>

                        <label>Origen del resultado</label>
                        <select
                          name="resultadoObtenidoaTravesde"
                          value={consulta.signosVitales.resultadoObtenidoaTravesde || "-1"}
                          onChange={(e) => {
                            setConsulta({
                              ...consulta,
                              signosVitales: {
                                ...consulta.signosVitales,
                                resultadoObtenidoaTravesde: e.target.value
                              }
                            });
                          }}
                        >
                          <option value="-1">Seleccione</option>
                          <option value="1">Laboratorio</option>
                          <option value="2">Tira de glucosa capilar</option>
                        </select>
                      </>
                    )}
                    </>
                    )}
                  </div>
                  )}
            </div>

            {/* Peso / Altura como en el primero */}
            <h3>Somatometría</h3>
            <label>Peso (kg)*</label>
             {perfil?.nom024 && (<SwitchDesconocido
                prendido={consulta.signosVitales.peso === "999"}
                onCambio={(prendido) => setConsulta({
                  ...consulta,
                  signosVitales: {
                    ...consulta.signosVitales,
                    peso: prendido ? "999" : ""
                  }
                })}
              />)}
              <input
                type="text"
                name="peso"
                placeholder="Ej: 70"
                value={consulta.signosVitales.peso}
                maxLength={7}
                disabled={consulta.signosVitales.peso === "999"}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    handleSignosVitalesChange(e);
                    return;
                  }
                  if (!validarFormatoPeso(value)) return;
                  handleSignosVitalesChange(e);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarPesoOnBlur(value);

                  if (!validarRangoPeso(normalizado)) {
                    msgPesoFueraRango();
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, peso: "" }
                    });
                  } else {
                    e.target.value = normalizado;
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, peso: normalizado }
                    });
                  }
                }}
              />
             
           <label>Talla (m)*</label>
             {perfil?.nom024 && ( <SwitchDesconocido
                prendido={consulta.signosVitales.altura === "999"}
                onCambio={(prendido) => setConsulta({
                  ...consulta,
                  signosVitales: {
                    ...consulta.signosVitales,
                    altura: prendido ? "999" : ""
                  }
                })}
              />)}
              <input
                type="text"
                name="altura"
                placeholder="Ej: 1.75"
                value={consulta.signosVitales.altura}
                maxLength={5}
                disabled={consulta.signosVitales.altura === "999"}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    handleSignosVitalesChange(e);
                    return;
                  }
                  if (!validarFormatoAltura(value)) return;
                  handleSignosVitalesChange(e);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarAlturaOnBlur(value);

                  if (!validarRangoAltura(normalizado)) {
                    msgAlturaFueraRango();
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, altura: "" }
                    });
                  } else {
                    e.target.value = normalizado;
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, altura: normalizado }
                    });
                  }
                }}
              />
            {perfil?.nom024 && (
            <>
            <label>Circunferencia de cintura (cm)</label>
              <input
                type="text"
                name="circunferenciaCintura"
                placeholder="Ej: 85"
                value={consulta.signosVitales.circunferenciaCintura || ""}
                maxLength={3}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    handleSignosVitalesChange(e);
                    return;
                  }
                  if (!validarFormatoCircunferenciaCintura(value)) return;
                  handleSignosVitalesChange(e);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarEnteroCircunferenciaCinturaOnBlur(value);

                  if (!validarRangoCircunferenciaCintura(normalizado)) {
                    msgCircunferenciaCinturaFueraRango();
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, circunferenciaCintura: "" }
                    });
                  } else {
                    e.target.value = normalizado;
                    setConsulta({
                      ...consulta,
                      signosVitales: { ...consulta.signosVitales, circunferenciaCintura: normalizado }
                    });
                  }
                }}
              />
                </>
            )}
            <label>IMC</label>
            <input
              type="number"
              step="0.01"
              name="imc"
              value={consulta.imc}
              readOnly
              disabled
            />

            <label>Categoría IMC</label>
            <input
              name="categoria_imc"
              value={consulta.categoria_imc}
              readOnly
              disabled
            />
        </div>
      </Accordion>
       {/* 4) Estudios */}
      <Accordion
        title="Estudios"
        isOpen={openRubros["rubro-estudios"]}
        onToggle={() => toggleRubro("rubro-estudios")}
        anchorId="rubro-estudios"
      >

        <div className="rubro">
          <h3>Estudios de laboratorio y gabinete</h3>
          <textarea
            id="laboratorios_texto"
            name="laboratorios_texto"
            placeholder="Ingrese estudios de laboratorios y gabinete"
            value={consulta.laboratorios_texto}
            onChange={handleInputChange}
          ></textarea>
          <DropzoneArchivos
          onFilesSelected={(files) => setConsultaFiles(files)}
          archivosSeleccionados={consultaFiles}
        />
        </div>
      </Accordion>
      <Accordion
        title="Diagnóstico, pronóstico y plan de tratamiento"
        isOpen={openRubros["rubro-dx-plan"]}
        onToggle={() => toggleRubro("rubro-dx-plan")}
        anchorId="rubro-dx-plan"
       >
        <div className="rubro">
          <h3>Diagnósticos:</h3>
          
           {perfil?.nom024 && (
            <>
              <div className="subrubro" style={{ marginTop: 8 }}>
                <label>Relación temporal del diagnóstico principal*</label>
                <select
                  name="relacionTemporal"
                  value={consulta.relacionTemporal ?? ""}
                  onChange={(e) => {
                    const nuevoValor = e.target.value === "" ? null : Number(e.target.value);

                    setConsulta((prev) => ({
                      ...prev,
                      relacionTemporal: nuevoValor,
                      codigoCIEDiagnostico1: "",
                      codigoCIEDiagnostico2: "",
                      codigoCIEDiagnostico3: "",
                      primeraVezDiagnostico2: null,
                      primeraVezDiagnostico3: null,
                      confirmacionDiagnostica1: null,
                      confirmacionDiagnostica2: null,
                      confirmacionDiagnostica3: null,
                    }));

                    setDiagnosticosSeleccionados({ 1: null, 2: null, 3: null });
                    setDiagnosticoBusqueda({ 1: "", 2: "", 3: "" });
                    setDiagnosticosCatalogo([]);
                    setCieFields([1]);
                    setCieActivo(1);
                  }}
                >
                  <option value="">Seleccione</option>
                  <option value="0">Primera vez</option>
                  <option value="1">Subsecuente</option>
                </select>
              </div>

              {cieFields.map((num) => (
                <div key={num} style={{ marginBottom: 12 }}>
                  {num !== 1 && (
                    <div className="subrubro" style={{ marginTop: 8 }}>
                      <label>¿Es primera vez del diagnóstico {num}?</label>

                      <select
                        name={`primeraVezDiagnostico${num}`}
                        value={consulta[`primeraVezDiagnostico${num}`] ?? ""}
                        onChange={(e) =>
                          setConsulta((prev) => ({
                            ...prev,
                            [`primeraVezDiagnostico${num}`]:
                              e.target.value === "" ? "" : Number(e.target.value),
                            [`codigoCIEDiagnostico${num}`]: "",
                            [`confirmacionDiagnostica${num}`]: null,
                          }))
                        }
                      >
                        <option value="">Seleccione</option>
                        <option value="1">Sí</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  )}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      gap: 8,
                      marginBottom: 8,
                      alignItems: "start"
                    }}
                  >
                    <div className="cie-autocomplete">
                      <input
                        type="text"
                        placeholder="Escribe el diagnóstico y escoge el CIE correcto*."
                        value={diagnosticoBusqueda[num]}
                        onFocus={() => {
                          if (perfil?.nom024 && !consulta.fechaConsulta) {
                            toast.error("Primero seleccione la fecha de consulta.");
                            return;
                          }

                          if (
                            perfil?.nom024 &&
                            !["0", "1"].includes(String(consulta.relacionTemporal).trim())
                          ) {
                            toast.error("Primero seleccione la relación temporal del diagnóstico principal.");
                            return;
                          }

                          if (
                            perfil?.nom024 &&
                            num !== 1 &&
                            !["0", "1"].includes(String(consulta[`primeraVezDiagnostico${num}`]).trim())
                          ) {
                            toast.error(`Primero indique si el diagnóstico ${num} es de primera vez.`);
                            return;
                          }

                          setCieActivo(num);
                        }}
                        onChange={(e) => {
                          if (perfil?.nom024 && !consulta.fechaConsulta) {
                            toast.error("Primero seleccione la fecha de consulta.");
                            return;
                          }

                          if (
                            perfil?.nom024 &&
                            !["0", "1"].includes(String(consulta.relacionTemporal).trim())
                          ) {
                            toast.error("Primero seleccione la relación temporal del diagnóstico principal.");
                            return;
                          }

                          if (
                            perfil?.nom024 &&
                            num !== 1 &&
                            !["0", "1"].includes(String(consulta[`primeraVezDiagnostico${num}`]).trim())
                          ) {
                            toast.error(`Primero indique si el diagnóstico ${num} es de primera vez.`);
                            return;
                          }

                          const value = e.target.value.toUpperCase();

                          if (
                            consulta[`codigoCIEDiagnostico${num}`] &&
                            value !== diagnosticoBusqueda[num]
                          ) {
                            setConsulta((prev) => ({
                              ...prev,
                              [`codigoCIEDiagnostico${num}`]: "",
                              [`confirmacionDiagnostica${num}`]: null
                            }));

                            setDiagnosticosSeleccionados((prev) => ({ ...prev, [num]: null }));
                            setDiagnosticoBusqueda((prev) => ({ ...prev, [num]: "" }));
                            setDiagnosticosCatalogo([]);
                            setCieActivo(num);
                            return;
                          }

                          setDiagnosticoBusqueda((prev) => ({ ...prev, [num]: value }));
                          setCieActivo(num);
                        }}
                        onBlur={() => {
                          if (!consulta[`codigoCIEDiagnostico${num}`]) {
                            setDiagnosticoBusqueda((prev) => ({ ...prev, [num]: "" }));
                          }
                        }}
                      />

                      {cieActivo === num && diagnosticosCatalogo.length > 0 && (
                        <div className="cie-dropdown">
                          {diagnosticosCatalogo.map((dx) => (
                            <div
                              key={`${num}-${dx.CATALOG_KEY}`}
                              className="cie-option"
                              onMouseDown={(e) => {
                                e.preventDefault();

                                const otrosCodigos = cieFields
                                  .filter((n) => n !== num)
                                  .map((n) => consulta[`codigoCIEDiagnostico${n}`])
                                  .filter(Boolean);

                                if (otrosCodigos.includes(dx.CATALOG_KEY) && dx.CATALOG_KEY !== "R69X") {
                                  toast.warning("Este diagnóstico ya fue registrado. Seleccione uno diferente.");
                                  return;
                                }

                                setConsulta((prev) => ({
                                  ...prev,
                                  [`codigoCIEDiagnostico${num}`]: dx.CATALOG_KEY
                                }));

                                setDiagnosticosSeleccionados((prev) => ({
                                  ...prev,
                                  [num]: dx
                                }));

                               const nombreCieLimpio = String(dx.NOMBRE || "").replace(/\s+/g, " ").trim();

                                setDiagnosticoBusqueda((prev) => ({
                                  ...prev,
                                  [num]: `${nombreCieLimpio} - ${dx.CATALOG_KEY}`
                                }));

                                setDiagnosticosCatalogo([]);
                                setCieActivo(num);
                              }}
                            >
                              {dx.NOMBRE} - {dx.CATALOG_KEY}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div style={{ display: "flex", gap: 4 }}>
                      <button
                        type="button"
                        className="tab"
                        onClick={() => eliminarCampoCIE(num)}
                        disabled={cieFields.length === 1}
                      >
                        –
                      </button>
                      <button
                        type="button"
                        className="tab"
                        onClick={agregarCampoCIE}
                        disabled={cieFields.length === 3}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {(() => {
                    const dx = diagnosticosSeleccionados[num];
                    const esPrimeraVez = num === 1
                      ? String(consulta.relacionTemporal).trim() === "0"
                      : consulta[`primeraVezDiagnostico${num}`] === 1;

                    if (!aplicaConfirmacionDiagnostica(
                        dx,
                        calcularEdadEnFechaConsulta(paciente?.fecha_nacimiento, consulta?.fechaConsulta),
                        esPrimeraVez
                      )) return null;

                    return (
                      <div key={`conf-${num}`} className="subrubro" style={{ marginTop: 8 }}>
                        <label>
                          ¿Se confirma el diagnóstico {num} ({consulta[`codigoCIEDiagnostico${num}`]})?
                        </label>

                        <select
                          name={`confirmacionDiagnostica${num}`}
                          value={consulta[`confirmacionDiagnostica${num}`] ?? ""}
                          onChange={(e) =>
                            setConsulta((prev) => ({
                              ...prev,
                              [`confirmacionDiagnostica${num}`]:
                                e.target.value === "" ? null : Number(e.target.value)
                            }))
                          }
                        >
                          <option value="">Seleccione</option>
                          <option value="1">Sí</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    );
                  })()}
                </div>
              ))}
            </>
          )}

           <CampoAsistido
            tipo="textarea"
            campo="diagnosticos"
            name="diagnostico"
            placeholder="Describa los diagnósticos"
            value={consulta.diagnostico || ""}
            onChange={handleInputChange}
            sugerenciasHistoricasHabilitadas={
              perfil?.sugerencias_historicas_habilitadas ?? true
            }
            buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
            onOcultarSugerenciaHistorica={handleOcultarSugerenciaHistorica}
          />
        </div>

        <div className="rubro">
          <h3>Pronóstico:</h3>
          <CampoAsistido
            tipo="textarea"
            campo="pronostico"
            name="pronostico"
            placeholder="Describa el pronóstico"
            value={consulta.pronostico || ""}
            onChange={handleInputChange}
            plantillasHabilitadas={perfil?.plantillas_habilitadas ?? false}
            plantillasPersonalizadas={
              Array.isArray(perfil?.plantillas_personalizadas)
                ? perfil.plantillas_personalizadas
                : []
            }
          />
        </div>

        <div className="rubro">
          <h3>Plan de Tratamiento:</h3>
          {/* Intervenciones de Salud Mental y Adicciones */}
          {perfil?.nom024 && (
        <div className="subrubro" style={{ marginTop: "12px" }}>
          <label>Intervenciones de Salud Mental y Adicciones</label>
          <select
            name="intervencionesSMyA"
            value={consulta.intervencionesSMyA ?? "-1"}
            onChange={handleInputChange}
          >
            <option value="-1">Seleccione</option>
            <option value="1">Intervención psicosocial</option>
            <option value="2">Tratamiento farmacológico</option>
            <option value="3">Ambos</option>
          </select>
        </div>
         )}
        {/* ✅ Medicamentos (estructurados) */}
          <label>Tratamiento</label>
          {medicamentos.map((med, index) => (
            <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <CampoAsistido
                campo="medicamentos"
                placeholder="Medicamento (p. ej., Paracetamol 500 mg)"
                value={med.nombre || ""}
                onChange={(e) => {
                  const nuevos = [...medicamentos];

                  nuevos[index] = {
                    ...nuevos[index],
                    nombre: e.target.value,
                    vademecum_id: nuevos[index]?.vademecum_id ?? null,
                  };

                  setMedicamentos(nuevos);
                }}
                sugerenciasHistoricasHabilitadas={
                  perfil?.sugerencias_historicas_habilitadas ?? true
                }
                buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
                onOcultarSugerenciaHistorica={handleOcultarSugerenciaHistorica}
              />
              <CampoAsistido
                campo="posologia"
                placeholder="Indicaciones (dosis, frecuencia, duración)"
                value={med.indicaciones || ""}
                onChange={(e) => {
                  const nuevos = [...medicamentos];

                  nuevos[index] = {
                    ...nuevos[index],
                    indicaciones: e.target.value,
                    vademecum_id: nuevos[index]?.vademecum_id ?? null,
                  };

                  setMedicamentos(nuevos);
                }}
                sugerenciasHistoricasHabilitadas={
                  perfil?.sugerencias_historicas_habilitadas ?? true
                }
                buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
                onOcultarSugerenciaHistorica={handleOcultarSugerenciaHistorica}
              />

              <button
                type="button"
                className="tab"
                onClick={() => {
                  const nuevos = medicamentos.filter((_, i) => i !== index);
                  setMedicamentos(nuevos.length ? nuevos : [{ nombre: "", indicaciones: "", vademecum_id: null }]);
                }}
              >
                -
              </button>
              <button
                type="button"
                className="tab"
                onClick={() =>
                  setMedicamentos([...medicamentos, { nombre: "", indicaciones: "", vademecum_id: null }])
                }
              >
                +
              </button>
            </div>
          ))}
          <label>Plan</label>
          <CampoAsistido
            tipo="textarea"
            campo="planTratamiento"
            name="tratamiento"
            placeholder="Describa el plan (laboratorios, recomendaciones generales)"
            value={consulta.tratamiento || ""}
            onChange={handleInputChange}
            plantillasHabilitadas={perfil?.plantillas_habilitadas ?? false}
            plantillasPersonalizadas={
              Array.isArray(perfil?.plantillas_personalizadas)
                ? perfil.plantillas_personalizadas
                : []
            }
          />
        
        </div>

        <div className="rubro">
          <h3>Indicaciones Adicionales:</h3>
          <textarea 
            id="indicacionesAdicionales" 
            name="indicacionesAdicionales" 
            placeholder="Describa las indicaciones adicionales"
            value={consulta.indicacionesAdicionales} 
            onChange={handleInputChange}>
          </textarea>
        </div>
      </Accordion>
      <CuestionarioPorEspecialidadConsulta
        rubroId="rubro-cuestionario-especialidad-consulta"
        especialidadMedico={especialidadConsulta}
        consulta={consulta}
        setConsulta={setConsulta}
        openRubros={openRubros}
        toggleRubro={toggleRubro}
        selectedKeys={selectedKeysConsulta}
        nom024={perfil?.nom024 ?? false}
        edadPaciente={calcularEdadEnFechaConsulta(
          paciente?.fecha_nacimiento,
          consulta?.fechaConsulta
        )}
        edadMesesPaciente={calcularEdadMesesEnFechaConsulta(
          paciente?.fecha_nacimiento,
          consulta?.fechaConsulta
        )}
        sexo={paciente?.sexo}
        fechaNacimiento={paciente?.fecha_nacimiento}
      />

      <button type="submit" disabled={loadingSubmit}>
      {loadingSubmit ? "Guardando…" : "Registrar Consulta"}
      </button>
    </form>
    {showConsultaIncompleta && (
      <ModalConsultaIncompleta
        faltantes={faltantesConsulta}
        tipo="consulta"
        onClose={() => {
          setShowConsultaIncompleta(false);
          setFaltantesConsulta([]);
        }}
      />
    )}
     {/* 
      Se utiliza una sola instancia del modal para ambas validaciones.
      tipoEdadBloqueante determina si debe mostrar al paciente
      o al prestador y qué fecha de nacimiento debe evaluar.
    */}
    {tipoEdadBloqueante && (
      <ModalEdadPaciente
        modo="bloqueante"
        tipoPersona={tipoEdadBloqueante}
        fechaNacimiento={
          tipoEdadBloqueante === "prestador"
            ? medico?.fecha_nacimiento
            : paciente?.fecha_nacimiento
        }
        fechaConsulta={consulta?.fechaConsulta}
        onClose={() => setTipoEdadBloqueante(null)}
      />
    )}
    <ModalConfirmacion
      isOpen={showConfirm}
      onClose={() => setShowConfirm(false)}
      onConfirm={() => {
        setShowConfirm(false);
        handleSubmit(); // llama tu guardado real
      }}
      tipo="consulta"
    />
     {/* 1) Primero se revisa el perfil del médico */}
    {perfil?.nom024 && faltantes?.length > 0 && (
      <ModalPerfilIncompleto faltantes={faltantes} />
    )}

    {/* 2) Solo si el perfil está completo, se revisa al paciente
          (igual que en AltaHistoriaClinica, incluyendo la CURP del prestador) */}
    {perfil?.nom024 &&
      paciente &&
      (!faltantes || faltantes.length === 0) &&
      obtenerFaltantesPacienteNOM024(paciente, medico?.curpPrestador)?.length > 0 && (
        <ModalPacienteIncompleto
          faltantes={obtenerFaltantesPacienteNOM024(paciente, medico?.curpPrestador)}
          pacienteId={pacienteId}
        />
    )}
    </>
  );
};


export default ConsultaSeguimiento;
